export const banner_html_content = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  </head>
  <style>
    .banner_outer_outer_container {
      .anchor-tag {
        text-decoration: none;
        color: black;
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
      }
      .banner_outer_container {
        background-color: #0065e3;
        height: 200px;
        font-family: Gilroy;
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;

        .percentage-num {
          font-size: 36px;
        }

        .right-subsection-small {
          display: none;
        }

        .small-banner-image {
          display: none;
        }

        .heading,
        .small-heading {
          font-weight: 700;
          font-size: 41px;
          line-height: 101%;
          color: white;
          padding-bottom: 18px;
        }

        .small-heading {
          display: none;
        }

        .subheading {
          font-weight: 500;
          font-size: 25px;
          line-height: 23px;
          color: white;
        }

        .banner-image {
          height: 200px;
          width: auto;
        }
        .mid-section {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 57px;
        }
        .banner-right {
          background-image: url("https://assets.clear.in/cleartax/images/1757319582_group18142243611.png");
          background-position: left;
          background-repeat: no-repeat;
          font-weight: 700;
          font-size: 28px;
          line-height: 21px;
          white-space: nowrap;
          width: 384px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
        }
        .right-subsection,
        .right-subsection-small {
          padding-right: 40px;
          text-align: center;
        }
        .banner-button {
          text-decoration: none;
          font-family: Gilroy;
          font-weight: 700;
          margin-top: 10px;
          margin-right: 5px;
          line-height: 132%;
          border-radius: 4px;
          white-space: nowrap;
          padding: 10px 55px;
          font-size: 21px;
          color: #ffffff;
          background: #1572ed;
        }
        @media screen and (min-width: 1024px) and (max-width: 1439px) {
          .small-heading {
            font-size: 40px;
            display: block;
          }
          .heading {
            display: none;
          }
          .subheading {
            font-size: 20px;
            line-height: 15px;
          }
          .mid-section {
            padding-left: 30px;
          }
          .banner-right {
            background-image: url("https://assets.clear.in/cleartax/images/1757318991_group1814224362.png");
            background-position: left;
            background-repeat: no-repeat;
            width: 382px;
          }
          .right-subsection {
            font-size: 22px;
          }
          .banner-button {
            font-size: 18px;
          }
          .right-subsection {
            padding-right: 9px;
            font-size: 20px;
          }
          .banner-image {
            width: 332px;
          }
          .percentage-num {
            font-size: 36px;
          }
        }
        @media screen and (min-width: 768px) and (max-width: 1023px) {
          .small-heading {
            font-size: 31px;
            display: block;
          }
          .heading {
            display: none;
          }
          .subheading {
            font-size: 16px;
            line-height: 17px;
          }
          .mid-section {
            padding-left: 30px;
          }
          .banner-right {
            background-image: url("https://assets.clear.in/cleartax/images/1757321632_frame21472246052.png");
            background-position: left;
            background-repeat: no-repeat;
            width: 244px;
          }

          .right-subsection {
            font-size: 18px;
          }
          .banner-button {
            font-size: 18px;
          }
          .right-subsection {
            padding-right: 6px;
          }
          .banner-image {
            width: 222px;
          }
          .percentage-num {
            font-size: 24px;
          }
        }
        @media screen and (max-width: 767px) {
          .banner-image {
            display: none;
          }
          position: relative;
          .banner-right {
            background-image: url("https://assets.clear.in/cleartax/images/1757319102_itrfilinglivestaticbanner1440x2005.png");
            background-position: left;
            background-repeat: no-repeat;
            width: 209px;
          }
          .small-banner-image {
            display: block;
            height: 100px;
            width: 175px;
            position: absolute;
            top: 0;
            left: 0;
          }
          .small-heading {
            font-size: 20px;
            display: block;
            padding-left: 25px;
            padding-top: 110px;
          }
          .heading {
            display: none;
          }
          .subheading {
            font-size: 11px;
            line-height: 15px;
            padding-left: 25px;
            padding-bottom: 25px;
          }
          .mid-section {
            padding-left: 0px;
          }
          .right-subsection-small {
            font-size: 18px;
            padding-right: 20px;
            display: block;
          }
          .banner-button {
            font-size: 18px;
            padding: 8px 23px;
          }
          .right-subsection {
            display: none;
          }
          .percentage-num {
            font-size: 25px;
          }
          .banner-button {
            font-size: 10px;
          }
        }
      }
    }
  </style>
  <body style="margin: 0px; overflow-x: hidden">
    <div class="banner_outer_outer_container">
      <a
        href="https://cleartax.in/filing?utm_ref=itr_2025_organic_topcta_deadline"
        target="_blank"
        class="anchor-tag"
      >
        <div class="banner_outer_container">
          <div class="left-section">
            <picture>
              <source
                media="(min-width: 1440px)"
                srcset="
                  https://assets.clear.in/cleartax/images/1758537492_maskgroup1.webp
                "
              />
              <source
                media="(min-width: 1024px)"
                srcset="
                  https://assets.clear.in/cleartax/images/1758537496_maskgroup2.webp
                "
              />
              <source
                media="(min-width: 768px)"
                srcset="
                  https://assets.clear.in/cleartax/images/1758537498_maskgroup3.webp
                "
              />
              <img
                class="banner-image"
                src="https://assets.clear.in/cleartax/images/1758537498_maskgroup3.webp"
                alt="itr-deadline-15th-september-banner"
                width="182"
                height="200"
                fetchpriority="high"
                loading="eager"
              />
            </picture>
          </div>
          <div class="mid-section">
            <picture>
              <img
                class="small-banner-image"
                src="https://assets.clear.in/cleartax/images/1758537501_maskgroup4.webp"
                alt="itr-deadline-15th-september-banner"
                width="182"
                height="200"
                fetchpriority="high"
                loading="eager"
              />
            </picture>
            <div class="heading">Missed the deadline?</div>
            <div class="small-heading">
              Missed the <br />
              deadline?
            </div>
            <div class="subheading">File ITR with 100% Accuracy</div>
          </div>
          <div class="banner-right">
            <div class="right-subsection-small">
              <div class="banner-button">File Now</div>
            </div>
            <div class="right-subsection">
              <div class="banner-button">File Now</div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </body>
</html>
`;
